module.exports = __webpack_public_path__ + "static/media/empty_space.2ff6dcaa.png";